module.exports = __webpack_public_path__ + "assets/qianbi.bef0c7d2.svg";